module.exports = ".chart-padding {\n  padding: 25px 60px 5px;\n}\n"